import React, { Component } from 'react';
import { connect } from 'react-redux';

import { message } from 'antd';
import { browserHistory } from 'react-router';
import { querySaveDepartmentCustom } from '@api/crm/crm';
import FormCustom from './FormCustom';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = { data: {} };
  }

  handleAdd = params => {
    querySaveDepartmentCustom(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ data: nextProps.data });
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <FormCustom
          ref={form => {
            this.form = form;
          }}
          handleSubmit={this.handleAdd}
          data={data}
        />
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/PageAdd.js